
export enum ActionTypes {
  SET_MODE_OPERATION = 'SET_MODE_OPERATION'
}

export type MODE_TYPE = {
 isDemo:boolean
}